import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Popover} from "react-bootstrap";
import './ProblemPopover.css';

class ProblemPopover extends Component {
    static propTypes = {
        data: PropTypes.object.isRequired,
        onReport: PropTypes.func,
        close: PropTypes.func.isRequired
    };
    static defaultProps = {};
    state = {
        problemComment: this.props.data.problemComment
    };

    render() {
        const {onReport, close, data, ...props} = this.props;
        return (
            <Popover id="supplier-rate-popover" {...props}>
                <div className="m-b-1">
                    <p>
                        Для продолжения введите комментарий и нажмите на кнопку <strong>Отправить</strong>.
                    </p>
                </div>
                <div className="m-b-2">
                    <textarea className="form-control" placeholder="Комментарий"
                              rows="2"
                              value={this.state.problemComment}
                              onChange={event => this.setState({problemComment: event.target.value})}/>
                </div>
                <div className="clearfix">
                    <button type="button" className="btn btn-default btn-3d"
                            onClick={() => close()}>
                        Отмена
                    </button>
                    <button type="button" className="btn btn-success btn-3d pull-right"
                            onClick={() => this.reportProblem()}>
                        Отправить
                    </button>
                </div>
            </Popover>
        );
    }

    reportProblem() {
        const {onReport} = this.props;

        if (onReport) onReport({
            problemComment: this.state.problemComment
        });
    }
}

export default ProblemPopover;


// WEBPACK FOOTER //
// ./src/pages/TenderBlock/TenderRequests/popovers/ProblemPopover.js